import React from 'react';
import { useNavigate } from 'react-router';
import styled from "styled-components";

const Container = styled.div`
    height: 30%;
    width: 100%;
    @media (min-width: 500px) {
        width: 90%;
    }
    @media (min-width: 1050px) {
        width: 20%;
    }
`;
const Nav = styled.div`
    width: 90%;
    padding:10px;
    margin-right: 100px;
    background-color: var(--main-light-grey-color);
    color: var(--main-teal-color);
    box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
    @media (max-width: 1050px) {
        display:flex;
        justify-content:center;
        width: 100%;
    }
`;

const NavIcon = styled.img`
    width: 30%;
    height: auto;
    margin: 5px;
`;
const NavItem = styled.div`
    display:flex;
    padding:20px;
`;
const NavText = styled.div`
    width: 70%;
    font-family: Lato-Bold;
    font-size: 0.8rem;
    display:flex;
    align-items:center;
    transition: all 0.2s ease 0s;
    cursor:pointer;

        :hover {
            transition: all 0.2s ease 0s;
            color: var(--main-orange-color);
        }
`;
function DashboardNav() {

    const navigate = useNavigate();
    
    return (
        <Container>
            <Nav>
                <NavItem>
                    <NavIcon src="/images/homepage/calendar.png" />
                    <NavText onClick={() => navigate('/MyAccount/Details')}>My Details</NavText>
                </NavItem>
                <NavItem>
                    <NavIcon src="/images/homepage/calendar.png" />
                    <NavText onClick={() => navigate('/MyAccount/Bookings')}>My Bookings</NavText>
                </NavItem>
                <NavItem>
                    <NavIcon src="/images/homepage/calendar.png" />
                    <NavText onClick={() => navigate('/MyAccount/TermsAndConditions')}>Terms and Conditions</NavText>
                </NavItem>
            </Nav>
        </Container>
    );
}
export default DashboardNav;